import { Outlet } from "react-router-dom";
import ManagerHeader from "./ManagerHeader";
import { CContainer, CSpinner } from "@coreui/react";
import { Suspense, useEffect, useState } from "react";
import ManagerSideBar from "./ManagerSidebar";

function ManagerLayout(props) {
  const [isMounted, setMounted] = useState();

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <>
      {
        isMounted &&
        <div style={{ width: "max-content", minWidth: "100%" }}>
          <ManagerSideBar />
          <div className="wrapper d-flex flex-column min-vh-100 bg-light">
            <ManagerHeader />
            <div className="body flex-grow-1 px-3" style={{ backgroundColor: "#F5F6FB" }}>
              <CContainer lg>
                <Suspense fallback={<CSpinner color="primary" />}>
                  <Outlet />
                </Suspense>
              </CContainer>
            </div>
            {/* <ManagerFooter /> */}
          </div>
        </div>
      }
    </>
  );
}

export default ManagerLayout;
